import React from "react";
import { Outlet } from "react-router-dom";
import { Header } from "../components/Header/Header";

export const LayoutHome = () => {
	return (
		<>
			<div className={`grid grid-rows-layoutCel fixed inset-0 h-full bg-[#828282]`}>
				<Header title="Default" />
				<Outlet />
			</div>
		</>
	);
};
